module.exports = "/_next/static/files/2ed958e3fae6e9b4053ac174739f59f0.jpg";